import { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { ModalForm } from './ModalForm';

export function ChangePasswordButton() {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	function handleOnClick(): void {
		setIsOpen((prevState) => !prevState);
	}

	return (
		<>
			{/* eslint-disable jsx-a11y/anchor-is-valid */}
			<a onClick={handleOnClick} style={{ marginTop: '20px' }}>
				{I18n.get('Change password')}
			</a>
			<ModalForm visible={isOpen} onClose={handleOnClick} />
		</>
	);
}
